<template>
    <div>
        <div id="create-campaign">
            <div class="app-container mb-5">

                <div class="page-title mb-3">
                    <router-link to="/campaigns">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Mes campagnes
                        </span>
                    </router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span v-if="aspect" class="mr-2">{{aspectLabel}} - </span>
                    <span class="breadcrumb-item">
                        {{ cmaj.name }}
                    </span>
                </div>

                <v-stepper @change="setCurrentStep" :value="currentStep" non-linear>
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Formulaire
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Options d'envoi
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <informationReadOnly v-if="tabulations.length" :tabulations="tabulations" :select-all="true"
                                                 :categories="categories" :aspect="aspect">
                            </informationReadOnly>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <emailReadOnly v-if="cmaj.lastForm !== null" :webForm="cmaj.lastForm"></emailReadOnly>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <finalize v-if="cmaj.lastForm !== null" :readOnly="true"
                                      :criterias="criterias" :hasSuggestionOption="hasSuggestionOption"></finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>

            </div>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapState } from "vuex"
import InformationReadOnly from "./stepers/InformationReadOnly"
import EmailReadOnly from "./stepers/EmailReadOnly.vue"
import Finalize from "./stepers/Finalize"
import { aspectElements } from "../../../static/webform"

export default {
    name: "CampaignConfig",
    components: { InformationReadOnly, EmailReadOnly, Finalize },
    data() {
        return {
            loading: false,
            cmajId: null,
            cmaj: {},
            tabulations: [],
            categories: [],
            criterias: [],
            hasSuggestionOption: false,
            aspect: null,
        }
    },
    methods: {
        ...mapMutations("createCmaj", ["setCurrentStep", "setFirstPartMail", "setLastPartMail", "setSender", "resetState",
            "setMediaSuggestion", "setPeriodsConfig", "setSelectedCriterias", "setNoEmail", "setSingleEmail",
            "setTxtIntro"]),
        getCmajConfig() {
            this.$global.loading = true
            this.$http.get("auth/account/apidae-criterias").then(res => {
                this.criterias = res.body.data.criterias

                this.$http.get("auth/campaigns/cmaj/config/" + this.cmajId).then(res => {
                    this.cmaj = res.body.data.cmaj
                    this.tabulations = res.body.data.tabulations
                    this.categories = res.body.data.categories
                    this.setNoEmail(this.cmaj.no_email)
                    this.setSingleEmail(this.cmaj.single_email)
                    this.setMediaSuggestion(this.cmaj.media_suggestion)
                    this.setPeriodsConfig(this.cmaj.periods_config)
                    this.setTxtIntro(this.cmaj.text_intro)
                    this.aspect = this.cmaj.aspect

                    if (this.cmaj.apidae_criterias) {
                        let selectedCriterias = []
                        this.cmaj.apidae_criterias.forEach(criteria => {
                            let selectedCriteria = this.criterias.find(element => element.id === criteria.external_id)
                            selectedCriterias.push(selectedCriteria.id)
                        })

                        this.setSelectedCriterias(selectedCriterias)
                    }
                })
            })
        },
        setHasSuggestionOption() {
            let option = undefined
            let exist = false

                this.account.current_contracts.forEach(contract => {
                    option = contract.contract_offer.options.find(option => option.code === "MEDIA_SUGGESTION")

                    if (option !== undefined) {
                        exist = true
                    }
                })

            this.hasSuggestionOption = exist
        },
    },
    computed: {
        ...mapState("createCmaj", ["currentStep"]),
        ...mapState('account', ['senders','account']),
        aspectLabel() {
            if(this.aspect !== undefined && this.aspect !== '') {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    created() {
        let hash = this.$route.params.hash
        this.cmajId = parseInt(atob(hash))

        this.setCurrentStep('1')
        this.getCmajConfig()
        this.setHasSuggestionOption()
    },
}
</script>